export const ACCESSORY_PATH_SEPARATOR = ' > ';

export const ACCESSORIES_CATEGORY_TREE = {
  Men: [
    'Belts',
    'Wallets & Card Holders',
    'Ties & Bow Ties',
    'Pocket Squares',
    'Suspenders',
    'Hats & Caps',
    'Scarves',
    'Gloves',
    'Sunglasses',
    'Eyewear Frames',
    'Cufflinks',
    'Tie Clips',
    'Keychains',
    'Umbrellas',
    'Phone & Tech Accessories (Wearable)',
    'Fashion Accessories',
  ],
  Women: [
    'Belts',
    'Wallets & Card Holders',
    'Hats & Caps',
    'Scarves & Shawls',
    'Gloves',
    'Sunglasses',
    'Eyewear Frames',
    'Hair Accessories',
    'Fashion Belts',
    'Brooches',
    'Keychains',
    'Umbrellas',
    'Phone & Tech Accessories (Wearable)',
    'Fashion Accessories',
  ],
  Kids: [
    'Hats & Caps',
    'Scarves',
    'Gloves',
    'Belts',
    'Wallets',
    'Sunglasses',
    'Hair Accessories',
    'Character Accessories',
    'School Accessories',
    'Umbrellas',
    'Fashion Accessories',
  ],
};

export const ACCESSORY_DEPARTMENTS = Object.keys(ACCESSORIES_CATEGORY_TREE);

export function isAccessoriesListingCategory(category) {
  return category === 'Accessories';
}

export function joinAccessorySubcategoryPath(parts) {
  return parts.filter(Boolean).join(ACCESSORY_PATH_SEPARATOR);
}

export function parseAccessorySubcategoryPath(value) {
  if (!value) {
    return { department: '', subcategory: '' };
  }
  const [department = '', subcategory = ''] = String(value).split(ACCESSORY_PATH_SEPARATOR);
  return { department, subcategory };
}

export function getAccessorySubcategories(department) {
  return ACCESSORIES_CATEGORY_TREE[department] || [];
}

export function getAccessoryDepartmentsForBrowse() {
  return ACCESSORY_DEPARTMENTS;
}
